import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'dayHourMinute'
})
export class DayHourMinutePipe implements PipeTransform {
    constructor(private translateService:TranslateService) {

    }
    transform(value: number): any {
        let m=null;
        let s=null;
        let h=null;
        let d=null;
        let time="";
            if (!value) {
                return '';
            }
            if(value>60){
              s=(value%60);
              m=Math.floor(value/60);
            }
            else{
              s=value;
            }
            if(m && m>60){
              h=Math.floor(m/60);
              m=(m%60);
            }
            if(h && h>24){
              d=Math.floor(h/24)
              h=(h%24);
            }
            if(d){
              time+=d.toString()+ this.translateService.instant("D")+" ";
            }
            if(h){
              time+=h.toString()+ this.translateService.instant("H")+" ";
            }
            if(m){
              time+=m.toString()+ this.translateService.instant("M")+" ";
            }
            time+=s.toString()+ this.translateService.instant("S")+" ";
            return time;
    }
}
